export enum PropertyType {
  Integer = 0,
  Double = 1,
  Boolean = 2,
  String = 3,
  Array = 4,
  Complex = 5
}
